import { useAuth, useStore } from '@/containers'
import { CouponArrowDown, CouponIconSimple } from '@/styles/Icon'
import { useState } from 'react'
import ModalVoucherList from '../Popup/ModalVoucherList'
import AffiliateDiscountSelect from './AffiliateDiscountSelect'
import FormRadioButtonItems from './FormRadioButtonItems'

interface FormDiscount {
  className?: string
  onClick?: () => void
  icon?: boolean
  disabled?: boolean
  isError?: boolean | string
  type?: 'button' | 'submit' | 'reset' | undefined
  typeButtonPrimary?: 'button' | 'submit' | 'reset' | undefined
  classButtonConfirm?: string
  id?: string
  name?: string
  value?: string
  primary?: boolean
  secondary?: boolean
  shippingMethod?: string
  discount?: number
  useBonus?: boolean
  onChangeBonus?: (val: boolean) => void
}

const FormDiscount = ({ shippingMethod, discount = 0, useBonus, onChangeBonus }: FormDiscount) => {
  const { selectedLang } = useStore()
  const { errorAuth, cart, user } = useAuth()
  const [showListCoupons, setShowListCoupons] = useState(false)

  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }

  return (
    <div className='discountBox rounded-xl bg-white px-4 py-2' id='voucher'>
      <div
        className=' relative mb-[5px] mt-2 flex h-[48px] w-full cursor-pointer flex-row items-center rounded-lg border border-gray-100 bg-white-600'
        onClick={() => setShowListCoupons(true)}
      >
        <span className='icon mx-[10px]'>
          <CouponIconSimple />
        </span>
        <span className='mt-1 text-[14px] leading-none tracking-tight'>
          Sử dụng mã giảm giá/ Voucher
        </span>
        <CouponArrowDown className='absolute right-[15px] top-[35%]' />
      </div>
      {!showListCoupons && cart?.coupons?.filter(e => e.mes).length > 0 && (
        <div className='mb-1 w-full text-mainBody font-normal leading-tight text-red'>
          Một trong số các voucher không hợp lệ, tiếp tục mua hàng mà không cần
          voucher đó
        </div>
      )}
      {discount && discount > 0 ? (
        <div className='mb-1 text-dark-400'>
          Đã áp dụng <strong>{cart.coupons.filter(e => !e.mes).length}</strong>{' '}
          mã (giảm{' '}
          <strong className={`font-bold text-red`}>
            {discount
              ?.toLocaleString(selectedLang as string, {
                style: 'currency',
                currency: currency(selectedLang as string),
              })
              .replace(/\s₫/g, 'đ')}
          </strong>
          )
        </div>
      ) : (
        ''
      )}

      <div className='w-full overflow-y-auto'>
        <FormRadioButtonItems className='flex flex-wrap !gap-2 '>
          {!errorAuth?.status &&
            cart?.coupons &&
            cart.coupons
              .filter(e => !e.mes)
              .map((e, i) => {
                return (
                  <div
                    key={i}
                    className={`voucherItem flex h-[38px] w-full max-w-[135px] justify-center  bg-[url('/assets/icons/couponAplly.svg')] bg-cover bg-no-repeat`}
                  >
                    <span className='self-center text-Voucher text-price'>
                      Giảm{' '}
                      {e.value
                        .toLocaleString(selectedLang as string, {
                          style: 'currency',
                          currency: currency(selectedLang as string),
                        })
                        .replace(/\s₫/g, 'đ')}
                    </span>
                  </div>
                )
              })}
        </FormRadioButtonItems>
        {!!user?.groupId && (
          <>
            <AffiliateDiscountSelect
              className='mb-2 mt-4'
              label='Trừ trực tiếp vào giá sản phẩm'
              description='(Không lấy thưởng, trừ vào giá sản phẩm)'
              value={useBonus}
              onChange={onChangeBonus}
            />
          </>
        )}
      </div>
      <ModalVoucherList
        showListCoupons={showListCoupons}
        setShowListCoupons={setShowListCoupons}
        shippingMethod={shippingMethod}
      />
    </div>
  )
}

export default FormDiscount
